// @flow
import React from "react"
import id from "../../../../id"

import "./style.css"

const Loader = (props) => <div id={id("loader", props)} className="loader" />

export default Loader
